import React, { useCallback, useEffect, useState } from 'react';
import style from './index.scss';
import classNames from '../../../Details/DetailedPage/common/classNames';
import GameItem from '../../../Details/Games/GameItem';
import useTranslate from '../../../Details/DetailedPage/hooks/useTranslate';
import translations from '../../../Details/DetailedPage/translations';

let portraitCount = 6;
let landscapeCount = 8;

const VerticalGamesView = (props) => {
    const { gameCodes, deviceSelector, isShowPlayButtonOnHover, trackChangeGameClick } = props;
    const { isLandscape, isMobile, isTablet, isDesktop } = deviceSelector;

    const getCount = useCallback(() => {
        return isLandscape || isDesktop || isTablet ? landscapeCount : portraitCount;
    }, [isLandscape, isDesktop, isTablet]);

    const getGamesToShow = useCallback((countGames) => {
        return gameCodes.slice(0, countGames);
    }, [gameCodes]);

    const resizeHandler = useCallback(() => {
        if (isDesktop) {
            setIsDesktopSmallWidth(window.innerWidth < 475);
        }
    }, [isDesktop]);

    const [games, setGames] = useState([]);
    const [isDesktopSmallWidth, setIsDesktopSmallWidth] = useState(window.innerWidth < 475);
    const t = useTranslate();

    useEffect(() => {
        window.addEventListener('resize', resizeHandler);
        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [resizeHandler]);

    useEffect(() => {
        setGames(getGamesToShow(getCount()));
    }, [gameCodes, getCount, getGamesToShow]);

    useEffect(() => {
        return () => {
            portraitCount = 6;
            landscapeCount = 8;
        };
    }, []);

    const onClickLoadMore = () => {
        landscapeCount += 8;
        portraitCount += 6;
        setGames(getGamesToShow(getCount()));
    };

    const isShowedAllGames = () => {
        return games.length === gameCodes.length;
    };

    return <div className={style.wrapper}>
        <div className={style.games}>
            {games.map((code) => {
                return <GameItem key={code}
                                 code={code}
                                 gameIndexInArray={games.indexOf(code) + 1}
                                 className={classNames(style.gameItemStyle,
                                     { [style.gameItemStyleLandscape]: isMobile && isLandscape || isTablet
                                         || isDesktop && !isDesktopSmallWidth })}
                                 imageClassName={style.gameImageStyle}
                                 showGameInfo={true}
                                 showFeatureIcons={false}
                                 isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                                 trackChangeGameClick={trackChangeGameClick}
                />;
                }
            )}
        </div>
        {isShowedAllGames() ? <></> : <div className={style.loadMoreWrapper}>
            <button
                className={style.loadMoreButton}
                onClick={onClickLoadMore}>
                {t(translations.loadMore)}
            </button>
        </div>}
    </div>;
};

export default VerticalGamesView;
